import { IconProps } from '../../IconProps';

export function IconFacebook(props: IconProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            data-testid="IconFacebook"
            {...props}
        >
            <path d="M17 3H7C4.791 3 3 4.791 3 7V17C3 19.209 4.791 21 7 21H12.621V14.039H10.278V11.314H12.621V9.309C12.621 6.985 14.042 5.718 16.116 5.718C16.815 5.716 17.513 5.752 18.208 5.823V8.253H16.78C15.65 8.253 15.43 8.787 15.43 9.575V11.31H18.13L17.779 14.035H15.414V21H17C19.209 21 21 19.209 21 17V7C21 4.791 19.209 3 17 3Z" />
        </svg>
    );
}
